import MobileNavigation from './MobileNavigation';
import LocationSelector from './LocationSelector';
import Dropdown from './Dropdown';

export default {
    name: 'StickyHeader', // Add explicit name for CMP compatibility
    
    data() {
        return {
            didScroll: false,
            lastScrollTop: 0,
            delta: 2,
            navbarHeight: 0,
            stickyHeaderInitialized: false, // ADD THIS for CMP compatibility
        }
    },

    mounted() {
        this.initStickyHeader(); // CHANGE THIS for CMP compatibility
    },

    methods: {
        initStickyHeader() {
            // Prevent double initialization
            if (this.stickyHeaderInitialized) {
                return;
            }

            if ($(window).scrollTop() === 0) {
                $('body').addClass('is-site-header--top');
                $(this.$refs.header).addClass('site-header--top');
            }else if($(window).scrollTop() > 0){
                $(this.$refs.header).addClass('site-header--down');
            }

            this.navbarHeight = $(this.$refs.header).outerHeight(true);

            $(window).scroll((event) => {
                this.didScroll = true;
            });

            setInterval(() => {
                if (this.didScroll) {
                    this.hasScrolled();
                    this.didScroll = false;
                }
            }, 150);

            this.stickyHeaderInitialized = true;
        },

        hasScrolled() {

            let st = $(window).scrollTop();

            if (st === 0) {
                $('body').addClass('is-site-header--top');

                if($('.has-icon-submenu .dropdown__menu.is-opened').length){
                    let scrollH = $('.has-icon-submenu .dropdown__menu.is-opened').prop('scrollHeight');
                    $('.site-header-placeholder').css("--custom-height", `${scrollH}px`)
                }

                return $(this.$refs.header).removeClass('site-header--down').removeClass('site-header--up').addClass('site-header--top');
            }

            // Make sure they scroll more than delta
            if (Math.abs(this.lastScrollTop - st) <= this.delta) {
                return;
            }

            // If they scrolled down and are past the navbar, add class .site-header--up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > this.lastScrollTop && st > 20) {
                // Scroll down
                $(this.$refs.header).removeClass('site-header--top').removeClass('site-header--up').addClass('site-header--down');
                $('body').removeClass('is-site-header--top');

                if (this.$refs.dropdown) {
                    this.$refs.dropdown.close();
                }
                if (this.$refs.language) {
                    this.$refs.language.close();
                }
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    $(this.$refs.header).removeClass('site-header--top').removeClass('site-header--down').addClass('site-header--up');
                    $('body').removeClass('is-site-header--top');
                }
            }

            this.lastScrollTop = st;
        }
    },

    components: {
        MobileNavigation,
        LocationSelector,
        Dropdown
    }
}


// WEBPACK FOOTER //
// ./assets/js/components/StickyHeader.js